/**
 * PLAYER TRANSACTIONS -- ENDPOINTS
 * @description
 * [ENDPOINTS] - These are the list of endpoints for the player transactions module
 */
// eslint-disable-next-line
export const PLAYER_TRANSACTIONS = {
  FIND_ALL: 'api/adm/wallet/v1/player/transaction-history',
  FILTER_OPTIONS: 'api/adm/wallet/v1/player/filters/transaction-history',
}
